import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'processing': false,
  'attaching': false,
  'error': '',
  'success': '',
  'attachError': '',
  'attachSuccess': '',
  'code': '',
  'invoiceSerial': '',
  'invoiceNumber': '',
  'invoiceDate': null,
  'invoicedQuantity': 0,
  'referralGuide': '',
  'receptionDate': null,
  'partCode': '',
  'claimedQuantity': 0,
  'claimCode': '',
  'requestCode': '',
  'dealerComments': '',
};

export const returnClaim = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.CLEAR_RETURN_CLAIM]: (state, action) => INITIAL_STATE,
    [ActionTypes.SELECT_RETURN_CLAIM]: (state, action) => ({
      ...state,
      ...action.payload,
      'error': '',
      'success': '',
    }),
    [ActionTypes.EDIT_RETURN_CLAIM_VALUE]: (state, action) => ({
      ...state,
      [action.payload.name]: action.payload.value,
    }),
    [ActionTypes.GET_SALE_RETURN_DATA_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
      'error': '',
    }),
    [ActionTypes.GET_SALE_RETURN_DATA_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      ...action.response.data,
    }),
    [ActionTypes.GET_SALE_RETURN_DATA_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'error': action.error.data.error,
    }),
    [ActionTypes.PROCESS_RETURN_CLAIM_REQUEST]: (state, action) => ({
      ...state,
      'processing': true,
      'error': '',
      'success': '',
    }),
    [ActionTypes.PROCESS_RETURN_CLAIM_SUCCESS]: (state, action) => ({
      ...state,
      'processing': false,
      'success': 'La solicitud de devolución se procesó satisfactoriamente',
    }),
    [ActionTypes.PROCESS_RETURN_CLAIM_FAILED]: (state, action) => ({
      ...state,
      'processing': false,
      'error': action.error.data.error,
    }),
    [ActionTypes.ADD_RETURN_CLAIM_ATTACHMENT_REQUEST]: (state, action) => ({
      ...state,
      'attaching': true,
      'attachError': '',
      'attachSuccess': '',
    }),
    [ActionTypes.ADD_RETURN_CLAIM_ATTACHMENT_SUCCESS]: (state, action) => ({
      ...state,
      'attaching': false,
    }),
    [ActionTypes.ADD_RETURN_CLAIM_ATTACHMENT_FAILED]: (state, action) => ({
      ...state,
      'attaching': false,
      'attachError': action.error.data.error,
    }),
    [ActionTypes.REMOVE_RETURN_CLAIM_ATTACHMENT_REQUEST]: (state, action) => ({
      ...state,
      'attaching': true,
      'attachError': '',
      'attachSuccess': '',
    }),
    [ActionTypes.REMOVE_RETURN_CLAIM_ATTACHMENT_SUCCESS]: (state, action) => ({
      ...state,
      'attaching': false,
    }),
    [ActionTypes.REMOVE_RETURN_CLAIM_ATTACHMENT_FAILED]: (state, action) => ({
      ...state,
      'attaching': false,
      'attachError': action.error.data.error,
    }),
  })(state, action);
};
